import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  Chip,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';

import {
  FilterListOutlined,
  KeyboardArrowDownOutlined,
  SearchOutlined
} from '@mui/icons-material';

import { clinicOptions } from '../../../Default/components/Home/components/data';

import {
  headerContainerSx,
  providerInfoSx,
  providerRowSx,
  searchIconSx
} from '../../../Default/components/Home/components/styles';

import {
  menuProps,
  textFieldSx,
  searchFieldSx,
  filterButtonSx,
  patientCountChipSx,
  providerNameSx,
  toolbarSx
} from '../../../../views/Common/components/Styles/InputStyles';

const PatientHeader = ({
  clinic,
  onClinicChange,
  onSearchChange,
  search,hideClinic
}) => {
  const [isSearchFocused, setIsSearchFocused] = useState(false);


  return (
    <Box sx={headerContainerSx}>
      <Box sx={providerRowSx}>
        <Box sx={providerInfoSx}>
          <Typography sx={providerNameSx}>Dr. Charles</Typography>

          <Chip
            label="100 Patients"
            size="small"
            sx={patientCountChipSx}
          />
        </Box>

        {!hideClinic && (
          <FormControl
            size="small"
            sx={{
              ...textFieldSx,
              width: 280,
              minWidth: 280
            }}>
            <Select
              IconComponent={KeyboardArrowDownOutlined}
              value={clinic}
              onChange={onClinicChange}
              MenuProps={menuProps}>
              {clinicOptions.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Box>

      <Box sx={toolbarSx}>
        <TextField
          placeholder="Search patients..."
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlined sx={searchIconSx} />
                </InputAdornment>
              )
            }
          }}
          sx={{
            ...searchFieldSx,
            width: 320
          }}
          value={search}
          onChange={onSearchChange}
          onFocus={() => setIsSearchFocused(true)}
          onBlur={() => {
            if (!search.trim()) {
              setIsSearchFocused(false);
            }
          }}
        />

        <Button
          startIcon={<FilterListOutlined sx={{ fontSize: 18 }} />}
          sx={filterButtonSx}
          variant="outlined">
          Filter
        </Button>
      </Box>
    </Box>
  );
};
PatientHeader.propTypes = {
  clinic: PropTypes.string.isRequired,
  onClinicChange: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired
};

export default PatientHeader;
